// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\LloydResult\ApiLloydResult.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { DataSetVersion, DataSetVersionData, DataSetVersionOptions } from 'data/models/DataSetVersion';
import { LloydServiceVessel, LloydServiceVesselData, LloydServiceVesselOptions } from 'data/models/LloydServiceVessel';
import { LloydVesselServiceQuery, LloydVesselServiceQueryData, LloydVesselServiceQueryOptions } from 'data/models/LloydVesselServiceQuery';

// LloydResultData is the class that LloydResult serializes to/from
export interface LloydResultData {
    Id : number;
	
    ServiceVessels : LloydServiceVesselData[] | null;
    VesselServiceQuery : LloydVesselServiceQueryData | null;
    VesselServiceQueryId : number | null;
	
    Breadth : string | null;
    CallSign : string | null;
    CoreShipInd : string | null;
    CreatedOnUtc : /* ISO8601 */ string;
    DataSetVersion : DataSetVersionData;
    DateOfBuild : string | null;
    Deadweight : string | null;
    Depth : string | null;
    Draught : string | null;
    FlagCode : string | null;
    FlagName : string | null;
    GrossTonnage : string | null;
    Guid : /* GUID */ string;
    IHSLRorIMOShipNo : string | null;
    KeelToMastHeight : string | null;
    LastUpdateDate : /* ISO8601 */ string;
    LengthOverallLOA : string | null;
    MMSI : string | null;
    OfficialNumber : string | null;
    Operator : string | null;
    PassengerCapacity : string | null;
    ShipName : string | null;
    ShipStatus : string | null;
    ShiptypeLevel2 : string | null;
    ShiptypeLevel3 : string | null;
    ShiptypeLevel4 : string | null;
    ShiptypeLevel5 : string | null;
    ShiptypeLevel5HullType : string | null;
    TEU : string | null;
    ThrustersDescriptiveNarrative : string | null;
    YearOfBuild : string | null;
}

// LloydResultOptions is the class which may be passed to the LloydResult constructor to define optional initial data values
export interface LloydResultOptions {
    Id : number;
	
    ServiceVessels? : LloydServiceVesselOptions[] | null;
    VesselServiceQuery? : LloydVesselServiceQueryOptions | null;
    VesselServiceQueryId? : number | null;
	
    Breadth? : string | null;
    CallSign? : string | null;
    CoreShipInd? : string | null;
    CreatedOnUtc? : /* ISO8601 */ string;
    DataSetVersion? : DataSetVersionOptions;
    DateOfBuild? : string | null;
    Deadweight? : string | null;
    Depth? : string | null;
    Draught? : string | null;
    FlagCode? : string | null;
    FlagName? : string | null;
    GrossTonnage? : string | null;
    Guid? : /* GUID */ string;
    IHSLRorIMOShipNo? : string | null;
    KeelToMastHeight? : string | null;
    LastUpdateDate? : /* ISO8601 */ string;
    LengthOverallLOA? : string | null;
    MMSI? : string | null;
    OfficialNumber? : string | null;
    Operator? : string | null;
    PassengerCapacity? : string | null;
    ShipName? : string | null;
    ShipStatus? : string | null;
    ShiptypeLevel2? : string | null;
    ShiptypeLevel3? : string | null;
    ShiptypeLevel4? : string | null;
    ShiptypeLevel5? : string | null;
    ShiptypeLevel5HullType? : string | null;
    TEU? : string | null;
    ThrustersDescriptiveNarrative? : string | null;
    YearOfBuild? : string | null;
}

export class LloydResult {
    public Id : DataSignal<number>;
	
    public ServiceVessels : SDataArray<LloydServiceVessel>;
    public VesselServiceQuery : DataSignal<LloydVesselServiceQuery | null>;
    public VesselServiceQueryId : DataSignal<number | null>;
	
    public Breadth : DataSignal<string | null>;
    public CallSign : DataSignal<string | null>;
    public CoreShipInd : DataSignal<string | null>;
    public CreatedOnUtc : DataSignal<TZDate>;
    public DataSetVersion : DataSetVersion;
    public DateOfBuild : DataSignal<string | null>;
    public Deadweight : DataSignal<string | null>;
    public Depth : DataSignal<string | null>;
    public Draught : DataSignal<string | null>;
    public FlagCode : DataSignal<string | null>;
    public FlagName : DataSignal<string | null>;
    public GrossTonnage : DataSignal<string | null>;
    public Guid : DataSignal<string>;
    public IHSLRorIMOShipNo : DataSignal<string | null>;
    public KeelToMastHeight : DataSignal<string | null>;
    public LastUpdateDate : DataSignal<TZDate>;
    public LengthOverallLOA : DataSignal<string | null>;
    public MMSI : DataSignal<string | null>;
    public OfficialNumber : DataSignal<string | null>;
    public Operator : DataSignal<string | null>;
    public PassengerCapacity : DataSignal<string | null>;
    public ShipName : DataSignal<string | null>;
    public ShipStatus : DataSignal<string | null>;
    public ShiptypeLevel2 : DataSignal<string | null>;
    public ShiptypeLevel3 : DataSignal<string | null>;
    public ShiptypeLevel4 : DataSignal<string | null>;
    public ShiptypeLevel5 : DataSignal<string | null>;
    public ShiptypeLevel5HullType : DataSignal<string | null>;
    public TEU : DataSignal<string | null>;
    public ThrustersDescriptiveNarrative : DataSignal<string | null>;
    public YearOfBuild : DataSignal<string | null>;

    constructor();
    constructor(data : LloydResultOptions);
    constructor(data: LloydResultOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.ServiceVessels = SArray<LloydServiceVessel>([]);
        this.VesselServiceQuery = S.value<LloydVesselServiceQuery | null>(null);
        this.VesselServiceQueryId = jsonableObservable(S.value<number | null>(data && data.VesselServiceQueryId !== undefined ? data.VesselServiceQueryId : null));
	    
        this.Breadth = jsonableObservable(S.value<string | null>(data && data.Breadth !== undefined ? data.Breadth : null));
        this.CallSign = jsonableObservable(S.value<string | null>(data && data.CallSign !== undefined ? data.CallSign : null));
        this.CoreShipInd = jsonableObservable(S.value<string | null>(data && data.CoreShipInd !== undefined ? data.CoreShipInd : null));
        this.CreatedOnUtc = jsonableObservable(S.value<TZDate>(data && data.CreatedOnUtc !== undefined ? new TZDate(data.CreatedOnUtc) : new TZDate(0), TZDate.eq));
        this.DataSetVersion = data && data.DataSetVersion !== undefined ? new DataSetVersion(data.DataSetVersion) : new DataSetVersion();
        this.DateOfBuild = jsonableObservable(S.value<string | null>(data && data.DateOfBuild !== undefined ? data.DateOfBuild : null));
        this.Deadweight = jsonableObservable(S.value<string | null>(data && data.Deadweight !== undefined ? data.Deadweight : null));
        this.Depth = jsonableObservable(S.value<string | null>(data && data.Depth !== undefined ? data.Depth : null));
        this.Draught = jsonableObservable(S.value<string | null>(data && data.Draught !== undefined ? data.Draught : null));
        this.FlagCode = jsonableObservable(S.value<string | null>(data && data.FlagCode !== undefined ? data.FlagCode : null));
        this.FlagName = jsonableObservable(S.value<string | null>(data && data.FlagName !== undefined ? data.FlagName : null));
        this.GrossTonnage = jsonableObservable(S.value<string | null>(data && data.GrossTonnage !== undefined ? data.GrossTonnage : null));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.IHSLRorIMOShipNo = jsonableObservable(S.value<string | null>(data && data.IHSLRorIMOShipNo !== undefined ? data.IHSLRorIMOShipNo : null));
        this.KeelToMastHeight = jsonableObservable(S.value<string | null>(data && data.KeelToMastHeight !== undefined ? data.KeelToMastHeight : null));
        this.LastUpdateDate = jsonableObservable(S.value<TZDate>(data && data.LastUpdateDate !== undefined ? new TZDate(data.LastUpdateDate) : new TZDate(0), TZDate.eq));
        this.LengthOverallLOA = jsonableObservable(S.value<string | null>(data && data.LengthOverallLOA !== undefined ? data.LengthOverallLOA : null));
        this.MMSI = jsonableObservable(S.value<string | null>(data && data.MMSI !== undefined ? data.MMSI : null));
        this.OfficialNumber = jsonableObservable(S.value<string | null>(data && data.OfficialNumber !== undefined ? data.OfficialNumber : null));
        this.Operator = jsonableObservable(S.value<string | null>(data && data.Operator !== undefined ? data.Operator : null));
        this.PassengerCapacity = jsonableObservable(S.value<string | null>(data && data.PassengerCapacity !== undefined ? data.PassengerCapacity : null));
        this.ShipName = jsonableObservable(S.value<string | null>(data && data.ShipName !== undefined ? data.ShipName : null));
        this.ShipStatus = jsonableObservable(S.value<string | null>(data && data.ShipStatus !== undefined ? data.ShipStatus : null));
        this.ShiptypeLevel2 = jsonableObservable(S.value<string | null>(data && data.ShiptypeLevel2 !== undefined ? data.ShiptypeLevel2 : null));
        this.ShiptypeLevel3 = jsonableObservable(S.value<string | null>(data && data.ShiptypeLevel3 !== undefined ? data.ShiptypeLevel3 : null));
        this.ShiptypeLevel4 = jsonableObservable(S.value<string | null>(data && data.ShiptypeLevel4 !== undefined ? data.ShiptypeLevel4 : null));
        this.ShiptypeLevel5 = jsonableObservable(S.value<string | null>(data && data.ShiptypeLevel5 !== undefined ? data.ShiptypeLevel5 : null));
        this.ShiptypeLevel5HullType = jsonableObservable(S.value<string | null>(data && data.ShiptypeLevel5HullType !== undefined ? data.ShiptypeLevel5HullType : null));
        this.TEU = jsonableObservable(S.value<string | null>(data && data.TEU !== undefined ? data.TEU : null));
        this.ThrustersDescriptiveNarrative = jsonableObservable(S.value<string | null>(data && data.ThrustersDescriptiveNarrative !== undefined ? data.ThrustersDescriptiveNarrative : null));
        this.YearOfBuild = jsonableObservable(S.value<string | null>(data && data.YearOfBuild !== undefined ? data.YearOfBuild : null));
    }

    static key(obj : LloydResult) {
        return obj.Id();
    }
    
    static dataKey(obj : LloydResultOptions) {
        return obj.Id;
    }

    static update(obj : LloydResult, data : LloydResultOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.VesselServiceQueryId !== undefined) obj.VesselServiceQueryId(data.VesselServiceQueryId);
	        
            if (data.Breadth !== undefined) obj.Breadth(data.Breadth);
            if (data.CallSign !== undefined) obj.CallSign(data.CallSign);
            if (data.CoreShipInd !== undefined) obj.CoreShipInd(data.CoreShipInd);
            if (data.CreatedOnUtc !== undefined) obj.CreatedOnUtc(new TZDate(data.CreatedOnUtc));
            if (data.DataSetVersion !== undefined) DataSetVersion.update(obj.DataSetVersion, data.DataSetVersion);
            if (data.DateOfBuild !== undefined) obj.DateOfBuild(data.DateOfBuild);
            if (data.Deadweight !== undefined) obj.Deadweight(data.Deadweight);
            if (data.Depth !== undefined) obj.Depth(data.Depth);
            if (data.Draught !== undefined) obj.Draught(data.Draught);
            if (data.FlagCode !== undefined) obj.FlagCode(data.FlagCode);
            if (data.FlagName !== undefined) obj.FlagName(data.FlagName);
            if (data.GrossTonnage !== undefined) obj.GrossTonnage(data.GrossTonnage);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.IHSLRorIMOShipNo !== undefined) obj.IHSLRorIMOShipNo(data.IHSLRorIMOShipNo);
            if (data.KeelToMastHeight !== undefined) obj.KeelToMastHeight(data.KeelToMastHeight);
            if (data.LastUpdateDate !== undefined) obj.LastUpdateDate(new TZDate(data.LastUpdateDate));
            if (data.LengthOverallLOA !== undefined) obj.LengthOverallLOA(data.LengthOverallLOA);
            if (data.MMSI !== undefined) obj.MMSI(data.MMSI);
            if (data.OfficialNumber !== undefined) obj.OfficialNumber(data.OfficialNumber);
            if (data.Operator !== undefined) obj.Operator(data.Operator);
            if (data.PassengerCapacity !== undefined) obj.PassengerCapacity(data.PassengerCapacity);
            if (data.ShipName !== undefined) obj.ShipName(data.ShipName);
            if (data.ShipStatus !== undefined) obj.ShipStatus(data.ShipStatus);
            if (data.ShiptypeLevel2 !== undefined) obj.ShiptypeLevel2(data.ShiptypeLevel2);
            if (data.ShiptypeLevel3 !== undefined) obj.ShiptypeLevel3(data.ShiptypeLevel3);
            if (data.ShiptypeLevel4 !== undefined) obj.ShiptypeLevel4(data.ShiptypeLevel4);
            if (data.ShiptypeLevel5 !== undefined) obj.ShiptypeLevel5(data.ShiptypeLevel5);
            if (data.ShiptypeLevel5HullType !== undefined) obj.ShiptypeLevel5HullType(data.ShiptypeLevel5HullType);
            if (data.TEU !== undefined) obj.TEU(data.TEU);
            if (data.ThrustersDescriptiveNarrative !== undefined) obj.ThrustersDescriptiveNarrative(data.ThrustersDescriptiveNarrative);
            if (data.YearOfBuild !== undefined) obj.YearOfBuild(data.YearOfBuild);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/LloydResult.ts